export default __webpack_public_path__ + "static/media/dy.02e0fe46.png";